/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Self_Missing_TitleInputs */



/**
* | output |
* | --- |
* | "Limited Knowledge Access" |
*
* @param {Project_Access_Self_Missing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_self_missing_title = /** @type {((inputs?: Project_Access_Self_Missing_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Self_Missing_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingeschränkter Wissenszugriff")
	return /** @type {LocalizedString} */ ("Limited Knowledge Access")
});